import { useState } from 'react';

import { FormTypes } from 'constants/forms';
import { useDispatch, useSelector } from 'react-redux';

import { FormReplacementModal } from 'components/FormReplacementModal/FormReplacementModal';

import { getFormBundles, getForms, selectForms } from 'api/forms-slice';

const REFERENCE_FORM_TYPES = [FormTypes.CUSTOM, FormTypes.LIBRARY, FormTypes.INTELLIGENT];

const isReplacementFor = (candidate, form) => {
  const isReferenceForm = REFERENCE_FORM_TYPES.includes(form.type);
  const sameKind = isReferenceForm
    ? REFERENCE_FORM_TYPES.includes(candidate.type) && !!candidate.typeform_id
    : candidate.type === form.type;

  return (
    sameKind &&
    candidate.id !== form.id &&
    !candidate.public &&
    !candidate.archived &&
    !candidate.deleted
  );
};

export const useFormReplacement = ({ onArchive, onDelete }) => {
  const dispatch = useDispatch();
  const forms = useSelector(selectForms);
  const [pending, setPending] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const intercept = async (form, action) => {
    const bundles = await getFormBundles(form);
    if (bundles.length === 0) return false;

    await dispatch(getForms());
    setPending({ form, bundles, action });
    return true;
  };

  const handleConfirm = async replacements => {
    const { form, action } = pending;
    setSubmitting(true);
    try {
      const succeeded = await (action === 'delete' ? onDelete : onArchive)(form, replacements);
      if (succeeded) setPending(null);
    } finally {
      setSubmitting(false);
    }
  };

  const replacementOptions = pending
    ? Object.values(forms)
        .filter(Array.isArray)
        .flat()
        .filter(candidate => isReplacementFor(candidate, pending.form))
    : [];

  const modal = (
    <FormReplacementModal
      visible={!!pending}
      action={pending?.action}
      bundles={pending?.bundles}
      replacementOptions={replacementOptions}
      isSubmitting={submitting}
      onClose={() => setPending(null)}
      onConfirm={handleConfirm}
    />
  );

  return { intercept, modal };
};
